import { mediaData } from '@/mocks/gossipData';

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            吃瓜视频
          </h2>
          <p className="text-foreground-500 text-base">热门娱乐话题视频解读</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/10 transition-colors"></div>
                <div className="absolute bottom-3 right-3 bg-foreground-950/70 text-white text-xs px-2.5 py-1 rounded-md font-medium backdrop-blur-sm whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.views}次播放</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}